<template>
  <Card
    :value="value.reference"
    :to="{ name: 'project-lead-edit', params: { reference: value.reference.id, id: value.id } }"
    class="contact-lead"
    theme="list"
  />
</template>

<script>
import Card from '@/components/Project/Card'
export default {
  props: {
    value: Object,
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.contact-lead {
  .link-card__image {
    height: 2.5rem;
  }
}
</style>
